import { ChatCopyMessage } from '@agent/agent-interface/contact-view/chat/model/chat-copy-message';

export class ChatCopyInfo {
  public roomId: string;
  public copyMessages: ChatCopyMessage[];
  public copyKey: string | undefined;

  constructor(roomId: string, copyMessages: ChatCopyMessage[], fullCopyKey?: string) {
    this.roomId = roomId;
    this.copyMessages = copyMessages;
    this.copyKey = fullCopyKey;
  }
}
